<template>
  <div class="c-video o-modal u-bg-black">
    <div class="o-container">

    <Header />

    <router-link class="c-video__back" :to="previousPageUrl">
      <Back />
    </router-link>

    <LazyiFrame v-if="hasLoaded"
      :videoSrc="'https://player.vimeo.com/video/' + this.currentProject.videoId"
    />

    <div class="c-video__metadata" v-if="hasLoaded">
      <div>
        <div class="u-bold">{{ currentProject.client }}</div>
        <div class="o-quote mb-xsmall">{{ currentProject.name }}</div>
      </div>

      <div class="u-text-small">
        <h3 class="u-bold">Agency</h3>
        <div class="mb-xsmall">{{ currentProject.agency }}</div>
      </div>

      <div class="u-text-small">
        <h3 class="u-bold">Director</h3>
        <div>{{ currentProject.director }}</div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header.vue';
import Back from '@/assets/svg/Cross-large.vue';
import LazyiFrame from '@/components/LazyiFrame.vue';
import { setTimeout } from 'timers';

export default {
  data() {
    return {
      mql: window.matchMedia('(orientation: landscape)'),
    };
  },
  components: { Header, Back, LazyiFrame },
  computed: mapState({
    currentProject(state) {
      return state.projects[this.$route.params.project];
    },
    previousPage(state) {
      return state.groups[this.$route.params.group];
    },
    previousPageUrl(state) {
      if (this.$route.name.includes('private')) {
        return `/private/${this.previousPage.slug}`;
      } else {
        return `/${this.previousPage.slug}`
      }
    },
    hasLoaded: state => state.hasLoaded,
    title(state) {
      return state.hasLoaded ? state.seo.projects[this.$route.params.project].title : state.defaultMetaTitle;
    },
    description(state) {
      return state.hasLoaded ? state.seo.projects[this.$route.params.project].description : state.defaultMetaDescription;
    },
  }),
  methods: {
    forceRepaint() {
      const video = this.$el;
      setTimeout(() => {
        video.style.display="none";
        video.offsetHeight;
        video.style.display="block";
      }, 1000);
    },
  },
  mounted() {
    this.mql.addListener(this.forceRepaint);
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.description,
      }],
    };
  },
};
</script>